/**
 * SOJ Core Modern - Main JavaScript Entry Point
 *
 * This file is ready for site-specific JavaScript code.
 * All core functionality is handled by core.js and its modules.
 *
 * @package SOJ_Core_Modern
 * @since 2.0.0
 * @author Son of Jesse
 */

// Import core functionality (this will initialize all modules)
import core, { scheduleAfterNextPaint } from "./core.js";

// Import animation systems
import AnimationSystem from "./modules/animations.js";
import GSAPAnimationSystem from "./modules/gsap-animations.js";

// Import GSAP and plugins so they are available globally
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

// Import header animation functionality
import { initHeaderScrollBehavior } from "./modules/header-animation.js";
import { initDeferredPictures } from "./modules/deferred-pictures.js";

// Expose GSAP and plugins globally for block scripts
window.SOJ_initDeferredPictures = initDeferredPictures;

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.SplitText = SplitText;
gsap.registerPlugin(ScrollTrigger, SplitText);

// Initialize animation systems
let animationSystem;
let gsapAnimationSystem;

document.addEventListener("DOMContentLoaded", function () {
  // Cheap / LCP-related: hydrate images + header state immediately.
  initDeferredPictures(document);
  initHeaderScrollBehavior();

  // GSAP ScrollTrigger measures the whole page — defer past first paint
  // so it does not inflate Lighthouse "forced reflow" during load.
  scheduleAfterNextPaint(() => {
    animationSystem = new AnimationSystem();
    gsapAnimationSystem = new GSAPAnimationSystem();
    window.SOJ_ANIMATIONS = animationSystem;
    window.SOJ_GSAP_ANIMATIONS = gsapAnimationSystem;
  });
});
